import React, { useState, useRef } from "react";
import { Box, IconButton } from "@mui/material";
import { ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon } from "@mui/icons-material";

export default function ImageSlider({ images, alt, height = "210px", onImageClick }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  if (!images || images.length === 0) return null;
  if (images.length === 1) {
    return (
      <Box
        onClick={(e) => { if (onImageClick) { e.stopPropagation(); onImageClick(0); } }}
        style={{ position: "relative", width: "100%", height, overflow: "hidden", backgroundColor: "#f7f7f7", cursor: onImageClick ? "zoom-in" : "default" }}
      >
        <img src={images[0]} alt={alt} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      </Box>
    );
  }

  const handlePrev = (e) => { if (e) e.stopPropagation(); setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1)); };
  const handleNext = (e) => { if (e) e.stopPropagation(); setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0)); };

  return (
    <Box
      onTouchStart={(e) => { touchStartX.current = e.targetTouches[0].clientX; }}
      onTouchMove={(e) => { touchEndX.current = e.targetTouches[0].clientX; }}
      onTouchEnd={() => {
        const diff = touchStartX.current - touchEndX.current;
        if (diff > 45) handleNext();
        else if (diff < -45) handlePrev();
      }}
      style={{ position: "relative", width: "100%", height, overflow: "hidden", backgroundColor: "#181818", userSelect: "none" }}
    >
      <Box style={{ display: "flex", width: "100%", height: "100%", transform: `translateX(-${currentIndex * 100}%)`, transition: "transform 0.35s cubic-bezier(0.25, 1, 0.5, 1)" }}>
        {images.map((imgUrl, idx) => (
          <Box
            key={idx}
            onClick={(e) => { if (onImageClick) { e.stopPropagation(); onImageClick(idx); } }}
            style={{ flex: "0 0 100%", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#202020", cursor: onImageClick ? "zoom-in" : "default" }}
          >
            <img src={imgUrl} alt={`${alt} - ${idx + 1}`} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </Box>
        ))}
      </Box>
      <IconButton onClick={handlePrev} size="small" style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", backgroundColor: "rgba(255, 255, 255, 0.88)", color: "#222", zIndex: 3, width: 30, height: 30 }}>
        <ChevronLeftIcon style={{ fontSize: "1.2rem" }} />
      </IconButton>
      <IconButton onClick={handleNext} size="small" style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", backgroundColor: "rgba(255, 255, 255, 0.88)", color: "#222", zIndex: 3, width: 30, height: 30 }}>
        <ChevronRightIcon style={{ fontSize: "1.2rem" }} />
      </IconButton>
      <Box style={{ position: "absolute", bottom: "10px", right: "12px", backgroundColor: "rgba(0, 0, 0, 0.65)", color: "#fff", padding: "2px 8px", borderRadius: "12px", fontSize: "0.72rem", fontWeight: 700, fontFamily: "'Raleway', sans-serif", zIndex: 3, pointerEvents: "none" }}>
        {currentIndex + 1} / {images.length}
      </Box>
    </Box>
  );
}
